import { Box, Button, DialogActions, Divider, Grid, styled } from '@mui/material';
import { OrderJobAsset } from '../../../redux/slices/slice_types';
import PolarisIcon from '@/components/_common/PolarisIcon';
import { Dialog } from '@/components/_common';
import { useMemo, useState } from 'react';
import Autocomplete from '@/components/_common/Form/Autocomplete';
import { useAppDispatch, useAppSelector } from '@/redux/hooks';
import { selectCustomers } from '@/redux/selectors/constantsSelectors';
import axios from 'axios';
import { LoadingButton } from '@mui/lab';
import { useToast } from '@/components/_common/Toast';
import { getData } from '@/redux/slices/dataTableSlice';

interface SelectVendorProps {
  data: OrderJobAsset;
}

const SelectVendor = ({ data }: SelectVendorProps) => {
  const dispatch = useAppDispatch();
  const { success, error } = useToast();
  const customers = useAppSelector(selectCustomers);
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState(null);
  const [loading, setLoading] = useState(false);
  const customersList = useMemo(() => Object.keys(customers).map((customer) => customer), [customers]);

  const handleOpen = (e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setOpen(true);
  }
  const handleClose = (e?:React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (e) e.stopPropagation();
    setOpen(false);
  }

  const handleSubmit = async (e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    e.stopPropagation();
    setLoading(true);
    const action = await axios.post(`/api/v1/jobs/assets/${data.hid}/action/`, {customer: value});
    setLoading(false);
    if (action.status !== 200) {
      error('Failed to select Vendor');
    } else {
      dispatch(getData());
      success('Vendor selected successfully');
      handleClose();
    }    
  }

  return (
    <ButtonContainer>
      <Button
        color="primary"
        variant='contained'
        sx={{ whiteSpace: 'nowrap', textTransform: 'capitalize', width: '100%' }}
        endIcon={<PolarisIcon icon="profiles" />}
        onClick={handleOpen}
      >
        Select Vendor
      </Button>
      <Dialog
        open={open}
        onCancel={handleClose}
        showX
        title="Select Vendor"
        showButtons={false}
        onSubmit={handleSubmit}
        submitText="Select Vendor"
      >
        <Divider sx={{ mb: '2rem' }} />
        <Grid container spacing={2} width='100%'>
          <Grid item xs={12}>
            <Autocomplete
              label="Customer"
              required
              options={customersList}
              value={value}
              onChange={(el, val) => setValue(val)}
              disabled={customersList?.length === 1}
            />
          </Grid>
        </Grid>
        <Actions>
          <Button color="default" onClick={handleClose}>
            Cancel
          </Button>
          <LoadingButton disabled={!value} onClick={handleSubmit} type="submit" variant="contained" loading={loading}>
            Select Vendor
          </LoadingButton>
        </Actions>
      </Dialog>
    </ButtonContainer>
  );
};
export default SelectVendor;

const ButtonContainer = styled(Box)`
  display: flex;
`;

const Actions = styled(DialogActions)`
  margin: ${({ theme }) => theme.spacing(2, 2, 1)};
`;